import { useConfigStore } from 'src/stores/config'
import { watch } from 'vue'

const Boot = () => {
  const consent = window.VelocitiConsent

  if (!consent) {
    return
  }

  const config = useConfigStore()

  const tenantMeasurementId = () =>
    config.tenant?.salesToolGaMeasurementId !== undefined
      ? config.tenant.salesToolGaMeasurementId
      : config.tenant?.gaMeasurementId

  const destinations = () =>
    [...new Set([import.meta.env.VITE_GA_MEASUREMENT_ID, tenantMeasurementId()])].filter(
      (id): id is string => typeof id === 'string' && id.length > 0
    )

  // Keep the CMP integration available; opt back in at build time.
  const silktideEnabled = import.meta.env.VITE_SILKTIDE_ENABLED === 'true'

  consent.init({
    provider: silktideEnabled ? 'silktide' : null,
    defaults: { analytics_storage: silktideEnabled ? 'denied' : 'granted' },
    waitForUpdate: silktideEnabled ? 500 : 0,
    google: {
      measurementIds: destinations(),
    },
    inherit: { enabled: false },
  })

  const stopWatching = watch(tenantMeasurementId, () => consent.setDestinations(destinations()), { flush: 'sync' })

  if (import.meta.hot) {
    import.meta.hot.dispose(stopWatching)
  }
}

export default Boot
